export const ASSIGN_REVIEWER_USERS_QUERY_VARIABLES = {};
